import UUIDBase from '../UUIDBase'
import { localizeFieldName, useI18nInstance } from '@/plugins/i18n'
import Dinero, { Currency, Dinero as DineroType } from 'dinero.js'
import Pack from "@/models/inventory/Pack";
import ItemCustomPrice from "@/models/inventory/ItemCustomPrice";
import CustomPriceType from "@/models/inventory/CustomPrice";
import ItemPackCustomPrice from "@/models/inventory/ItemPackCustomPrice";

const { t } = useI18nInstance().global

export default class ItemPack extends UUIDBase {
    static from(json: Record<string, unknown> | ItemPack) {
        const itemPack = Object.assign(new ItemPack(), json)

        if (itemPack.listPriceAmount && itemPack.listPriceCurrency) {
            itemPack.listPriceDinero = Dinero({
                amount: itemPack.listPriceAmount,
                currency: itemPack.listPriceCurrency as Currency,
                precision: itemPack.listPricePrecision
            })
        }

        if (itemPack.salePriceAmount && itemPack.salePriceCurrency) {
            itemPack.salePriceDinero = Dinero({
                amount: itemPack.salePriceAmount,
                currency: itemPack.salePriceCurrency as Currency,
                precision: itemPack.salePricePrecision
            })
        }

        if (json.itemPackCustomPrices) {
            itemPack.itemPackCustomPrices = json.itemPackCustomPrices.map(i => ItemPackCustomPrice.from(i));
        }

        itemPack.createdAt = new Date(json.createdAt as string)
        itemPack.updatedAt = new Date(json.updatedAt as string)
        itemPack.deletedAt = json.deletedAt ? new Date(json.deletedAt as string) : undefined

        return itemPack
    }

    static ENDPOINT = '/inventory/itempacks'

    itemID?: string
    packID?: string
    pack?: Pack

    qty?: number
    barcode?: string
    sku?: string

    listPriceAmount?: number
    listPriceCurrency?: string
    listPricePrecision?: number
    listPriceDinero?: DineroType

    salePriceAmount?: number
    salePriceCurrency?: string
    salePricePrecision?: number
    salePriceDinero?: DineroType
    disabled = false

    itemPackCustomPrices = new Array<ItemPackCustomPrice>()
}
